import {
  Component,
  Input,
  LOCALE_ID,
  Signal,
  effect,
  forwardRef,
  inject,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { beneficialOwnersTranslations } from '@orgbrain/shareholders-lib';
import { getCountries, getCountryCallingCode, parsePhoneNumber } from 'libphonenumber-js';
@Component({
  selector: 'orgbrain-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class PhoneInputComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() phoneNumberLabel = '';
  @Input() countryCodeLabel = '';

  locale = inject(LOCALE_ID);

  preferedCodes = ['NO', 'SE', 'DK', 'GB'];
  countryCodes = getCountries()
    .map((code) => {
      const countryName = beneficialOwnersTranslations[code]?.[this.locale] || code;
      return {
        code: getCountryCallingCode(code),
        country: ' ' + countryName,
        important: this.preferedCodes.includes(code),
      };
    })
    .sort((a, b) => {
      if (a.important && !b.important) return -1;
      if (!a.important && b.important) return 1;
      return 0;
    });

  value = '';
  onChange: (val: string) => void = () => {};
  onTouched: () => void = () => {};
  outputChange = output<string>();

  countryCodeControl = new FormControl(getCountryCallingCode('NO'));
  phoneNumberControl = new FormControl('');

  countryCodeInput: Signal<string> = toSignal(this.countryCodeControl.valueChanges);
  phoneNumberInput: Signal<string> = toSignal(this.phoneNumberControl.valueChanges);

  updateValue = effect(() => {
    const phoneNumber = this.phoneNumberInput();
    const countryCode = this.countryCodeInput() || getCountryCallingCode('NO');

    if (!phoneNumber || !countryCode) return;
    this.value = '+' + String(countryCode) + String(phoneNumber);

    this.onChange(this.value);
    this.outputChange.emit(this.value);
    this.onTouched();
  });
  writeValue(val: any): void {
    if (!val) return;

    const parsedNumber = parsePhoneNumber(val);

    this.countryCodeControl.setValue(parsedNumber.countryCallingCode);
    this.phoneNumberControl.setValue(parsedNumber.nationalNumber);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
